<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="conts" :style="{background:'url('+loginBg+') no-repeat','background-size': backgroundSize}">
      <div class="heads">
        <div class="logo" :style="{'background-image':'url('+logo+')','background-size': '100% 100%;'}"></div>
        <div class="title">安陆顺安矿业有限公司售料系统</div>
      </div>
      <div class="bodys" :style="[{'height': screenHeight * 0.5 + 'px'}]">
        <route-view></route-view>
      </div>
       <div
        class="bottons"
        :style="[{'height': screenHeight * 0.06 + 'px'}]"
      >Copyright &copy; 2020~ {{companyName}}</div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'
import storage from '@/utils/storage'
import Bus from '@/layouts/bus'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data() {
    return {
      companyName: '恒赛特自动化科技有限公司',
      // zzshr 动画背景
      screenHeight: window.innerHeight, // 屏幕高度
      loginBg:'/login_bg.png',
      logo:'/logo.png',
      companyLogoId: '',
      backgroundSize: '100% 100%',
    }
  },
  created() {
    let loginBgId = storage.fetch('cache-loginBgId')
    let logoId = storage.fetch('cache-companyLogoId')
    if (loginBgId && loginBgId !== 'null'){
      this.loginBg = this.config.imgApiUrl + loginBgId
    }
    if (logoId && logoId !== 'null'){
      this.logo = this.config.imgApiUrl + logoId
    }
  },
  watch: {
    // zzshr 动画背景
    screenHeight: function(val) {
      // 监听屏幕高度变化
      var oIframe = document.getElementById('login')
      oIframe.style.height = Number(val) + 'px' // '120'是页面布局调整，可去除
    }
  },
  mounted() {
    document.body.classList.add('userLayout')

    var that = this
    // 用$on事件来接收参数
    Bus.$on('getCompanyInfo', (data, msg) => {
      if (data) {
        that.companyName = data.name
        if (data.loginBg){
          this.loginBg = this.config.imgApiUrl + data.loginBg
        }
        if (data.logo){
          this.logo = this.config.imgApiUrl + data.logo
        }
      }
    })
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
.conts::before {
  content: '';
  /*-webkit-filter: opacity(50%);
            filter: opacity(50%); */
  background-image: url(/in_top_bj.jpg);
  background-size: 100% 100%;
  opacity: 0.3; /* //透明度设置 */
  z-index: -1;
  width: 100%;
  height: 100%;
  position: absolute;
/*   //一定要设置position:absolute,这样才能设置z-index，让背景处于内容的下一层 */
  top: 0px;
  left: 0px;
}
.conts {
  background: url(/login_bg.png);
/*   background-size: 100% 100%; */
  /* background-repeat: no-repeat;  */ /* 这里会失效，需要设置到动态样式中 */
/*   background-size: 100% 100%; */
  padding-top: 90px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  position: relative;
  height: 250px;
  .heads {
    background: url(/login_warp.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
/*     // background-color: rgba(255, 255, 255, 0.8); */
   /*  background: radial-gradient(rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 70%); */
    height: 100px;
  /*   width: 50%; */
    width: 38%;
    margin: 0 25%;
    /* margin-top: 160px; */
    margin-top: 72px;
    .logo {
      height: 60px;
      width: 83px;
   /*    background-image: url(/logo.png);*/
      background-size: 100% 100%;
    }
    .title {
      margin-left: 20px;
      height: 60px;
      font-size: 30px;
      font-weight: 900;
      text-align: center;
      white-space:nowrap;
      line-height: 60px;
    }
  }
  .bodys {
    display: flex;
    justify-content: center;
  }
  .bottons {
    text-align: center;
    font-size: 18px;
/*     position: absolute; */
    bottom: 0;
    width: 100%;
  }
}
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    min-height: 100%;
    /*background: #629ae2 url(~@/assets/background.svg) no-repeat 50%;*/
    background-size: 100%;
    padding: 0 0 144px;
    position: relative;
    background: url(/login_bg.png);
    background-size: 100% 100%;

    .login_bg {
      width: 100%;
      height: 550px;
    }

    a {
      text-decoration: none;
    }

    .top {
      text-align: center;
      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }

    .main {
      min-width: 260px;
      width: 368px;
      margin: 0 auto;
    }

    .footer {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px;
      margin: 48px 0 24px;
      text-align: center;

      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: rgba(0, 0, 0, 0.45);
          transition: all 0.3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }
      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }
  }
}
</style>

